<div mat-dialog-title>
  <span>{{ "modals.chartSettings.edit.title" | translate }}</span>
  <button mat-icon-button class="dialog-close" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <app-chart-settings-form #form [values]="data.form?.values || {}" [withSubmit]="false" (onSubmit)="handleSubmit($event)"></app-chart-settings-form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="primary" [disabled]="dialogLoading" (click)="form.submit()">
    {{ "forms.general.buttons.save" | translate }}
  </button>
</mat-dialog-actions>
